class ModalSubscription extends Modal {
  static CLASS_NAME = 'modal-subscription';

  constructor(modalId) {
    super(modalId);

    this.$confirmButton = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__confirm`);
    this.$dataBlock = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__data`);
    this.$emailInput = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__email`);
    this.$countryInput = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__country`);
    this.$errorBlock = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__error`);
    this.$form = this.modal.querySelector(`form`);
    this.$submitButton = this.modal.querySelector(`.${ModalSubscription.CLASS_NAME}__submit`);

    this.$isLoading = false;
    this.$isDisabled = true;

    this.$errors = {
      emailError: this.$dataBlock.getAttribute('data-email-error'),
      requestError: this.$dataBlock.getAttribute('data-request-error')
    };

    this.$addEventListeners();
  }

  $addEventListeners() {
    this.$confirmButton.addEventListener('click', this.$onConfirmButtonClick);
    this.$emailInput.addEventListener('input', this.$onEmailInput);
    this.$form.addEventListener('submit', this.$onFormSubmit);
    this.$submitButton.addEventListener('click', this.$onSubmitButtonClick);
  }

  $hideError() {
    this.$emailInput.classList.remove(`${ModalSubscription.CLASS_NAME}__input--errored`);
    this.$errorBlock.style.display = 'none';
  }

  $onConfirmButtonClick = () => {
    this.close();
  }

  $onEmailInput = (event) => {
    this.$hideError();
    this.$setIsDisabled(!event.target.value);
  }

  $onFormSubmit = (event) => {
    event.preventDefault();
    this.$submit();
  }

  $onRequestError = () => {
    this.$showError(this.$errors.requestError);
  }

  $onRequestSuccess = () => {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      'event' : 'UA',
      'eventCategory' : 'lead_email',
      'eventAction' : 'subscribe',
      'eventLabel' : 'news_offers_style'
    });

    this.success();
  }

  $onSubmitButtonClick = (event) => {
    event.preventDefault();
    this.$submit();
  }

  $reset() {
    this.$emailInput.value = '';
    this.$setIsDisabled(true);
    this.$setIsLoading(false);
  }

  $sendRequest() {
    // const action = this.$form.getAttribute('action');
    // const method = this.$form.getAttribute('method');
    // const data = new FormData(this.$form);

    this.$sendSubscriptionToMindbox()
      .then(this.$onRequestSuccess)
      .catch(this.$onRequestError)
      .finally(() => this.$setIsLoading(false))


    // fetch(action, {
    //   method: method,
    //   body: data,
    //   credentials: 'same-origin'
    // }).then((response) => {
    //   if (response.ok) {
    //     this.$onRequestSuccess();
    //   } else {
    //     throw new Error('Request error');
    //   }
    // })
    // .then(() => this.$sendSubscriptionToMindbox())
    // .catch(() => {
    //   this.$onRequestError();
    // }).finally(() => {
    //   this.$setIsLoading(false);
    // });
    //
    // this.$setIsLoading(true);
  }

  $sendSubscriptionToMindbox() {
    return window.subscriptionService.subscribeEmail(
      {
        email: this.$emailInput.value,
        country: this.$countryInput.value
      })
  }

  $setIsDisabled(isDisabled) {
    const disabledClassName = `${ModalSubscription.CLASS_NAME}__submit--disabled`;

    this.$isDisabled = isDisabled;
    this.$submitButton.classList.toggle(disabledClassName, isDisabled);
  }

  $setIsLoading(isLoading) {
    const loadingClassName = `${ModalSubscription.CLASS_NAME}__submit--loading`;

    this.$isLoading = isLoading;
    this.$submitButton.classList.toggle(loadingClassName, isLoading);
  }

  $showError(errorText) {
    this.$emailInput.classList.add(`${ModalSubscription.CLASS_NAME}__input--errored`);
    this.$errorBlock.textContent = errorText;
    this.$errorBlock.style.display = 'block';
  }

  $submit() {
    if (!this.$isDisabled && !this.$isLoading && this.$validate()) {
      this.$sendRequest();
    }
  }

  $validate() {
    const isValid = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(this.$emailInput.value);

    if (!isValid) {
      this.$showError(this.$errors.emailError);
    }

    return isValid;
  }

  close() {
    super.close();
    this.$reset();
  }
}